export default __webpack_public_path__ + "static/media/google-pay.d502513d.svg";